export default __webpack_public_path__ + "static/media/Fees.f1937ce5.png";